/* eslint-disable consistent-return */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/require-default-props */
import React, { useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import { Container } from './styles';

interface ModalInterface {
  handleClose(): void;
  show: boolean;
  title?: string;
  icon?: any;
  success?: boolean;
  children: React.ReactNode;
}

const Modal: React.FC<ModalInterface> = ({
  handleClose,
  show,
  title,
  icon,
  children,
}) => {
  useEffect(() => {
    if (!show) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [show, handleClose]);
  return (
    <Container show={show}>
      <section className="modal-main">
        <>
          <button
            type="button"
            className="close-container"
            onClick={handleClose}
          >
            <FiX size={25} onClick={handleClose} />
          </button>
          {icon && <img src={icon} alt="icon" />}

          {title && (
            <div className="title">
              <h1>{title}</h1>
            </div>
          )}
          <div className="modal-body">{children}</div>
        </>
      </section>
    </Container>
  );
};

export default Modal;
